<template>
  <div class="page-container content-430">
    <div class="form_base">
      <div class="form-head">发布通知公告</div>
      <Form
        ref="formValidate"
        :label-width="100"
        :rules="ruleValidate"
        :model="formValidate"
      >
        <FormItem label="发布学校:" prop="schoolId">
          <ChooseSchool
            v-if="$route.query.type == 'add'"
            ref="chooseSchool"
            style="width:300px"
            @on-change="getSelectSchool"
          ></ChooseSchool>
          <span v-else>{{ schoolName }}</span>
        </FormItem>
        <Row class="relative" type="flex" flex="end">
          <FormItem label="通知标题:" prop="noticeTitle">
            <Input
              v-model="formValidate.noticeTitle"
              placeholder="请输入通知标题"
              style="width: 500px"
              clearable
              :maxlength="50"
            ></Input>
          </FormItem>
          <FormItem label="年度学期:" prop="termCode">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :placeholder="`请选择学期`"
              :cache-year-terms="cacheYearTerms"
              @on-init="onYearTermInit"
              @on-change="onYearTermChange"
            ></CascaderYearTerms>
          </FormItem>
        </Row>
        <FormItem
          label="通知内容:"
          class="editor-sytle html-reset"
          prop="noticeInfo"
        >
          <div id="wangeditor" ref="wangeditor"></div>
        </FormItem>
        <FormItem label="附件（图片）:" :label-width="110">
          <div v-show="imgList" class="imgWrap">
            <div v-for="(item, index) in imgList" :key="index" class="imgBox">
              <div class="rightBox"></div>
              <img v-if="item.imgSrc" :src="item.imgSrc" alt>
              <img v-else :src="item.localUrl" alt>
              <Icon
                type="ios-close"
                size="30"
                class="delBtn"
                @click="handleDelFile(index)"
              ></Icon>
            </div>
          </div>
          <UploadBtn
            :text="text"
            class="upload"
            :accept="`image/*`"
            :upload-type="uploadType2"
            @on-success="handleUploadImg1"
          ></UploadBtn>
          <div>最多上传9张图片(支持格式：jpg、png)</div>
        </FormItem>
      </Form>
    </div>
    <div class="form_base">
      <!-- 发送至 -->
      <div class="info">
        <div class="form-head">发送班级</div>
        <div style="margin-bottom: 30px" class="flex flexrow flexac">
          <div style="width: 110px; text-align: right">班级模式：</div>
          <RadioGroup v-model="noticeObject">
            <Radio
              :label="'CLASSROOM'"
              :value="'CLASSROOM'"
            >选择分班后的班级</Radio>
            <Radio
              :label="'SCHOOL'"
              :value="'SCHOOL'"
            >全校（行政班模式）</Radio>
            <Radio
              :label="'CLASS'"
              :value="'CLASS'"
            >选择行政班的年级/班级</Radio>
          </RadioGroup>
        </div>
        <div class="flex" style="padding-left: 30px">
          <div class="info_item">
            已选
            <span class="text red">{{
              noticeObject == 'CLASSROOM' ? notifyList.length : classIds.length
            }}</span>
            个班级
            <span class="text blue">{{
              noticeObject == 'CLASSROOM' ? noticeTotal : noticexzTotal
            }}</span>
            人
          </div>
          <Button
            class="search-430"
            type="primary"
            @click="handleClassBtn"
          >选择发送班级</Button>
        </div>
      </div>
      <!-- 定时发布 -->
      <div class="info">
        <div class="form-head">推送设置</div>
        <div class="info_item">
          <Form
            ref="formValidate"
            :label-width="120"
            :rules="ruleValidate"
            :model="formValidate"
          >
            <FormItem label="定时发布时间:" prop="timedSending">
              <DatePicker
                type="datetime"
                :value="formValidate.timedSending"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择时间"
                style="width: 600px"
                :clearable="false"
                transfer
                @on-change="changeDate"
              ></DatePicker>
              <!-- <div class="time-tip">
                选择的定时发布时间不得小于最终的审批时间前60分钟！
              </div> -->
            </FormItem>
            <FormItem label="推送渠道:" prop="ischeck">
              <Checkbox v-model="ischeck" :disabled="true">微信公众号</Checkbox>
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
    <div class="btn_wrap">
      <div class="btn">
        <Button style="width: 100px" @click="back">取消</Button>
        <Button
          type="primary"
          class="search-430"
          style="width: 100px"
          @click="handleSubmit"
        >发布</Button>
      </div>
    </div>
    <Spin v-if="spinShow" size="large" fix>
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <ChooseClassModal
      ref="ChooseClassModal"
      @on-finish="handleonFinish"
    ></ChooseClassModal>
    <selectClassCom
      ref="selectClassComRef"
      :org-id="formValidate.schoolId"
      :initclass-id="propclassId"
      :optype="type"
      :ctype="noticeObject"
      @on-finish="handleClassFinish"
    >
    </selectClassCom>
  </div>
</template>

<script>
import E from 'wangeditor';
import UploadBtn from '@c/UploadBtn';
import { mapState } from 'vuex';
import {
  getText,
  readFileOfImage,
  editorGetText,
  editorIsNull
} from '@/utils/utils';
import axios from 'axios';
import { compressPic } from '@/utils/imageHelper';
import ChooseClassModal from '@pv/eduCenter/common/assets/components/ChooseClassModal';
import eduCenter from '@/request/eduCenter/index.js';
import courseCenter from '@/request/courseCenter/index.js';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import selectClassCom from './selectClassCom.vue';
import ChooseSchool from '@c/searchBlock/ChooseSchool.vue';
export default {
  name: 'NoticeManageAddNotice',
  components: {
    UploadBtn,
    ChooseClassModal,
    CascaderYearTerms,
    selectClassCom,
    ChooseSchool
  },
  data() {
    return {
      propclassId: [],
      classIds: [],
      noticeObject: 'CLASSROOM',
      spinShow: false,
      noticeId: '', // 修改的id
      orgId: '', // 服务id
      notifyList: [], // 选择发送的班级列表
      noticeTotal: 0, // 人数
      noticexzTotal: 0, // 行政班人数
      imgList: [],
      UploadUrl: '',
      downloadUrl: '',
      text: '上传图片',
      uploadType2: 1,
      formValidate: {
        noticeTitle: '',
        termId: '',
        noticeInfo: '',
        photoIds: '',
        timedSending: '',
        isTiming: 0,
        termCode: '',
        yearCode: '',
        schoolId: ''
      },
      noticeType: 2,
      ischeck: true,
      ruleValidate: {
        noticeTitle: [
          { required: true, message: '请输入通知标题', trigger: 'blur' }
        ],
        termCode: [
          { required: true, type: 'number', message: '请选择年度学期', trigger: 'blur' }
        ],
        noticeInfo: [
          { required: true, message: '请输入通知详情', trigger: 'blur' }
        ],
        schoolId: [
          { required: true, message: '请选择发布学校', trigger: 'change' }
        ]

      },
      termList: [], // 年度学期
      editor: '',
      ClassList: [], // 选择的班级
      semesterList: [], // 学期列表
      portOrg: -1,
      lastTermId: '', // 记录学期上一次选择
      lastYearCode: '',
      lastTermCode: '',
      schoolName: '', // 学校名称
      cacheYearTerms: []
      // classroomIdArr: [], //班级id数组
    };
  },
  computed: { ...mapState(['userInfo']) },
  created() {
    console.log('this.$route.query', this.$route.query);
    this.portOrg = Number(localStorage.getItem('portOrg'));
    if (this.portOrg == 2) {
      this.noticeType = 1;
      this.schoolName = this.userInfo.orgName;
    } else {
      this.noticeType = 2;
      this.schoolName = localStorage.getItem('schoolName');
    }
    this.type = this.$route.query.type;
    this.orgId = this.$route.query.orgId;
    // this.schoolId = this.$route.query.schoolId;
    // this.getTermlist();
    this.getUploadtoken();
    if (this.$route.query.type == 'add') {
      this.formValidate = {};
      this.imgList = [];
    } else if (this.$route.query.type == 'classtoadd') {
      const data = JSON.parse(this.$route.query.item);

      this.schoolId = data.schoolId;
      this.formValidate.schoolId = data.schoolId;
      setTimeout(() => {
        this.fillClassform(data);
      }, 500);
    } else {
      const data = JSON.parse(this.$route.query.item);
      this.fillform(data);
      this.schoolId = data.schoolId;
      this.formValidate.schoolId = data.schoolId;
    }
  },
  mounted() {
    this.initE();
  },
  methods: {
    getSelectSchool({ schoolId, schoolName }) {
      this.schoolId = schoolId;
      this.formValidate.schoolId = schoolId;
      this.schoolName = schoolName;
    },
    initE() {
      this.editor = new E('#wangeditor');
      // 这里各位小伙伴可以查询官网，根据自己的需求进行菜单栏调整
      this.editor.config.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'foreColor', // 文字颜色
        'list', // 列表
        'justify' // 对齐方式
      ];
      this.editor.config.onblur = (html) => {
        this.dealEditorContext(html);
      };
      this.editor.create();
    },
    getEditorContect() {
      this.editor.isBlur ? '' : this.dealEditorContext(this.editor.txt.html());
    },
    // 处理富文本编辑器的内容
    dealEditorContext(html) {
      this.formValidate.noticeInfo = editorIsNull(editorGetText(html))
        ? ''
        : html;
    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then((res) => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    },
    // 获取图片下载地址
    getImgsrc(id) {
      return new Promise(async(resolve, reject) => {
        this.$http.getFileurl({ fileId: id }).then((res) => {
          if (res.status == 200) {
            const imgSrc = `${res.message.downUrl}?fileId=${id}`;
            resolve(imgSrc);
          }
        });
      });
    },
    back() {
      this.$router.go(-1);
    },
    onYearTermInit(val) {

    },
    //
    onYearTermChange(val) {
      if (this.lastYearCode) {
        this.$Modal.confirm({
          title: '提示',
          content: '选择学期，将不保留当前页面数据，是否继续',
          onOk: () => {
            this.formValidate = {
              photoIds: ''
            };
            this.notifyList = [];
            this.noticeTotal = 0;
            this.imgList = [];
            this.editor.txt.clear();
            this.formValidate.yearCode = val[0];
            this.formValidate.termCode = val[1];
            this.formValidate.schoolId = this.schoolId;
            this.lastYearCode = val[0];
            this.lastTermCode = val[1];
            this.$nextTick(() => {
              this.$refs.formValidate.validateField('termCode');
            });
          },
          onCancel: () => {
            this.formValidate.yearCode = this.lastYearCode;
            this.formValidate.termCode = this.lastTermCode;
            this.$refs.cascaderYearTerms.setYearTerms([this.lastYearCode, String(this.lastTermCode)]);
            this.$refs.formValidate.validateField('termCode');
          }
        });
      } else {
        this.formValidate.yearCode = val[0];
        this.formValidate.termCode = val[1];
        this.lastYearCode = val[0];
        this.lastTermCode = val[1];
        //  this.$refs.formValidate.validateField('yearCode')
      }
    },
    // 选择班级-打开弹框
    handleClassBtn() {
      if (this.noticeObject == 'CLASSROOM') {
        const yearTerms = this.$refs.cascaderYearTerms.getResult();
        this.formValidate.yearCode = yearTerms[0];
        this.formValidate.termCode = yearTerms[1];
        if (!this.formValidate.termCode) {
          this.$Message.error('请先选择年度学期');
          return false;
        }
        const data = this.notifyList.map((item) => {
          return {
            id: item.id,
            name: item.name,
            registeredNumbers: item.registeredNumbers
          };
        });
        this.$refs.ChooseClassModal.handleOpen(
          data,
          this.schoolId,
          this.formValidate.termId,
          this.formValidate.yearCode,
          this.formValidate.termCode
        );
      } else {
        this.$refs.selectClassComRef.open();
      }
    },
    // 班级列表总人数（去重）
    async postClassroomNumDistinct(data) {
      const res = await eduCenter.postClassroomNumDistinct(data);
      if (res.status === 200) {
        this.noticeTotal = res.message;
      }
    },
    // 选择班级-确定
    handleonFinish(data) {
      this.initClassData(data);
      this.$refs.ChooseClassModal.handleClosure();
    },
    handleClassFinish(e) {
      this.classIds = e.resultId;
      this.noticexzTotal = e.num;
      this.propclassId = e.resultId;
    },
    // 处理已选班级数据
    initClassData(data) {
      const stuData = [];
      this.notifyList = [];
      data.forEach((item) => {
        stuData.push(item.registeredNumbers);
        this.notifyList.push({
          id: item.id,
          name: item.name,
          registeredNumbers: item.registeredNumbers
        });
      });
      const classroomIdArr = this.notifyList.map((item) => item.id);
      this.postClassroomNumDistinct(classroomIdArr);
      // this.noticeTotal = stuData.reduce((x, y) => x + y);
    },
    // 改变时间
    changeDate(time) {
      this.formValidate.timedSending = time;
      this.$refs.formValidate.validateField('timedSending');
    },
    // 删除成果展示图片
    handleDelFile(index) {
      this.imgList.splice(index, 1);
    },
    uploadImg(ev) {
      return new Promise(async(resolve, reject) => {
        await this.getUploadtoken();
        const file = ev;
        const formData = new FormData();
        formData.append('token', this.uploadToken);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        axios.post(this.UploadUrl, formData, configs).then((res) => {
          if (res.data.status == 200) {
            const id = res.data.message.fileId;
            resolve(id);
          } else {
            this.spinShow = false;
            this.$Message.warning(res.data.error);
          }
        });
      });
    },
    checkImgType(type) {
      return ['png', 'jpg'].some((item) => item == type);
    },

    // 上传多张图片
    async handleUploadImg1(files) {
      if (this.imgList.length > 8) {
        this.$Message.warning('最多上传9张图片！');
        return false;
      }
      const file = files[0];
      const fileSize = file.size;
      const filekb = fileSize / 1024; // 转kb
      const fileName = file.name;
      const fileFormat = fileName.substring(fileName.lastIndexOf('.') + 1);
      if (filekb > 1 * 1024 * 10) {
        this.$Message.warning('单张图片最大支持上传10M');
        return false;
      }
      if (!this.checkImgType(fileFormat)) {
        this.$Message.warning('图片仅支持格式：jpg、png');
        return false;
      }
      try {
        this.imgSrc = '';
        const result = await readFileOfImage(file);
        let yaImageStr = ''; // 压缩后的base64图片

        // 如果图片大小大于200k,先进行压缩
        if (Math.round(fileSize / 1024) > 200) {
          yaImageStr = await compressPic(result, {
            quality: 0.7
          });
        } else {
          yaImageStr = result;
        }
        const obj = {
          localUrl: yaImageStr,
          file: file
        };
        this.imgList.push(obj);
      } catch (error) {
        console.log(error);
        this.$Message.warning('读取图片失败');
      }
    },

    // 增加通知公告
    async postNoticeSave() {
      this.spinShow = true;
      const arr = [];
      if (this.imgList.length) {
        for (const key in this.imgList) {
          if (this.imgList[key].file != undefined) {
            arr.push(await this.uploadImg(this.imgList[key].file));
          } else {
            arr.push(this.imgList[key].fid);
          }
        }
        this.formValidate.photoIds = getText(arr);
      }
      const classroomIdObj = {};
      this.notifyList.forEach((item) => {
        classroomIdObj[item.id] = item.name;
      });
      // const classroomIdArr = this.notifyList.map((item) => item.id);
      const params = Object.assign({}, this.formValidate, {
        orgId: this.orgId,
        schoolId: this.schoolId, // 发布至学校id
        schoolName: this.schoolName, // 学校名称
        noticeObject: this.noticeObject,
        creator: this.userInfo.id, // 发布人id
        createName: this.userInfo.name, // 发布人名字
        noticeTotal: this.noticeObject == 'CLASSROOM' ? this.noticeTotal : this.noticexzTotal,
        noticeType: this.noticeType
      });
      // 通知对象列表
      if (this.noticeObject == 'CLASSROOM') {
        params.classroomId = classroomIdObj;
      } else {
        params.classIds = this.classIds;
      }
      const res = await eduCenter.postNoticeSave(params);
      if (res.status == 200) {
        this.spinShow = false;
        this.$Message.success('提交成功，通知审批通过后，才算真正发布成功哦！');

        this.$router.go(-1);
      } else {
        this.spinShow = false;
        // this.$Message.error("新增失败");
      }
    },

    // 修改通知公告
    async postupdate() {
      this.spinShow = true;
      const arr = [];
      if (this.imgList.length) {
        for (const key in this.imgList) {
          if (this.imgList[key].file != undefined) {
            arr.push(await this.uploadImg(this.imgList[key].file));
          } else {
            arr.push(this.imgList[key].fid);
          }
        }
        this.formValidate.photoIds = getText(arr);
      }
      const classroomIdObj = {};
      this.notifyList.forEach((item) => {
        classroomIdObj[item.id] = item.name;
      });
      // const classroomIdArr = this.notifyList.map((item) => item.id);
      const params = Object.assign({}, this.formValidate, {
        noticeId: this.noticeId,
        orgId: this.orgId,
        schoolId: this.schoolId, // 发布至学校id
        schoolName: this.schoolName, // 学校名称
        noticeObject: this.noticeObject,
        creator: this.formValidate.creator, // 发布人id
        createName: this.formValidate.createName, // 发布人名字
        noticeTotal: this.noticeObject == 'CLASSROOM' ? this.noticeTotal : this.noticexzTotal,
        noticeType: this.noticeType
      });
      // 通知对象列表
      if (this.noticeObject == 'CLASSROOM') {
        params.classroomId = classroomIdObj;
      } else {
        params.classIds = this.classIds;
      }
      const res = await eduCenter.postupdate(params);
      if (res.status == 200) {
        this.spinShow = false;
        this.$Message.success('提交成功，通知审批通过后，才算真正发布成功哦！');
        this.$router.go(-1);
        // setTimeout(() => {
        // }, 100);
        // if (type == 1) {
        //   this.putApproveUpdate1();
        // } else {
        //   this.$Message.success("修改成功");
        //   this.$router.go(-1);
        // }
      } else {
        this.spinShow = false;
        this.$Message.error('修改失败');
      }
    },
    // 审批 1通过 2驳回
    putApproveUpdate1() {
      const params = {
        noticeId: this.noticeId,
        noticeState: 1,
        reviewer: this.userInfo.id,
        reviewName: this.userInfo.name
      };
      eduCenter.putApproveUpdate1(params).then((res) => {
        if (res.status == 200) {
          this.$Message.success('发布成功');
          this.$router.go(-1);
        }
      });
    },
    // 获取时间相差分
    getTimeCha(sendTime) {
      const dateBegin = new Date(); // 获取当前时间
      const dateEnd = new Date(sendTime);
      const dateDiff = dateEnd.getTime() - dateBegin.getTime(); // 时间差的毫秒数
      return dateDiff;
    },
    // 提交
    handleSubmit() {
      this.getEditorContect();
      const yearTerms = this.$refs.cascaderYearTerms.getResult();
      this.formValidate.yearCode = yearTerms[0];
      this.formValidate.termCode = yearTerms[1];
      if (!this.formValidate.schoolId) {
        this.$Message.error('请选择发布学校');
        return false;
      }
      if (!this.formValidate.noticeTitle) {
        this.$Message.error('请输入动态标题');
        return false;
      }
      if (!this.formValidate.noticeInfo) {
        this.$Message.error('请输入通知内容');
        return false;
      }
      if (!this.formValidate.termCode) {
        this.$Message.error('请选择年度学期');
        return false;
      }
      // if (
      //   !this.formValidate.timedSending
      // ) {
      //   this.$Message.error("请输入定时发布时间");
      //   return false;
      // }
      if (
        this.formValidate.timedSending &&
        this.getTimeCha(this.formValidate.timedSending) < 0
      ) {
        this.$Message.error('定时发布时间不得小于当前时间');
        return false;
      }
      if (this.formValidate.timedSending) {
        this.formValidate.isTiming = 1;
      } else {
        this.formValidate.isTiming = 0;
      }
      // 通知对象列表
      if (this.noticeObject == 'CLASSROOM') {
        if (!this.notifyList.length) {
          this.$Message.error('请选择发送班级');
          return false;
        }
      } else {
        if (this.classIds.length == 0) {
          this.$Message.error('请选择发送班级');
          return false;
        }
      }

      if ((this.noticeObject == 'CLASSROOM' && !this.noticeTotal) || (this.noticeObject != 'CLASSROOM' && !this.noticexzTotal)) {
        this.$Message.error('班级人数为0，请重新选择班级后发布');
        return false;
      }
      if (this.type != 'edit') {
        this.postNoticeSave();
      } else {
        this.postupdate();

        // this.$Modal.confirm({
        //   title: "提示信息",
        //   content: "通知发布后，需通过审批才能真正发送成功，是否立即审批通过？",
        //   okText: "通过，立即发送",
        //   cancelText: "否，暂不发布",
        //   onOk: () => {
        //     this.postupdate(1);
        //   },
        //   onCancel: () => {
        //     this.postupdate(2);
        //   },
        // });
      }
    },
    // 分班管理 -跳转回填
    fillClassform(data) {
      this.formValidate.termId = data.termId;
      this.schoolName = data.schoolName;
      this.lastTermId = data.termId;
      this.noticeTotal = data.registeredNumbers;
      this.notifyList = [
        {
          id: data.classroomId,
          name: data.classroomName,
          registeredNumbers: data.registeredNumbers
        }
      ];
    },
    // 修改-回填
    async fillform(data) {
      this.noticeId = data.noticeId;
      this.getNoticeByNoticeId();
      // this.noticeTotal = data.noticeTotal;
      this.formValidate.noticeTitle = data.noticeTitle;
      this.formValidate.noticeInfo = data.noticeInfo;
      this.formValidate.timedSending = data.timedSending;
      this.formValidate.termId = data.termId;
      this.formValidate.creator = data.creator;
      this.formValidate.createName = data.createName;
      this.schoolName = data.schoolName;
      // this.propclassId = data.classIds;
      // this.lastTermId = data.termId;
      if (data.yearCode) {
        this.formValidate.yearCode = data.yearCode;
        this.formValidate.termCode = data.termCode;
        this.cacheYearTerms = [data.yearCode, String(data.termCode)];
        console.log('this.cacheYearTerms', this.cacheYearTerms);
      }
    },
    // 获取通知公告详情
    async getNoticeByNoticeId() {
      const params = {
        noticeId: this.noticeId
      };
      const res = await eduCenter.getNoticeByNoticeId(params);
      if (res.status == 200) {
        const data = res.message;
        this.noticeObject = res.message.noticeObject == 1 ? 'SCHOOL' : res.message.noticeObject == 2 ? 'CLASSROOM' : 'CLASS';
        this.editor.txt.html(data.noticeInfo);
        if (this.noticeObject == 'CLASSROOM') {
          this.notifyList = data.classroomNameNumVO.map((item) => {
            return {
              id: item.classroomId,
              name: item.classroomName,
              registeredNumbers: item.registeredNumbers
            };
          });
          this.noticeTotal = data.noticeTotal;
        } else {
          this.noticexzTotal = data.noticeTotal;
          this.classIds = Object.keys(data.classNameMap);
          this.propclassId = this.classIds;
        }
        if (data.photoIds && data.photoIds.length > 0) {
          const imgArr = data.photoIds;
          for (const key in imgArr) {
            const imgId = imgArr[key];
            const img = await this.getImgsrc(imgArr[key]);
            const obj = {
              fid: imgId,
              imgSrc: img
            };
            this.imgList.push(obj);
          }
        }
      }
    }

    /** === 有关选择学期start ===**/
    // async getTermlist() {
    //   const params = {
    //     orgId: this.orgId,
    //   };
    //   const res = await courseCenter.getyearTermsListByNew(params);
    //   if (res.status === 200) {
    //     this.semesterList = res.message;
    //   }
    // },

    /** === 有关选择学期end ===**/
  }
};
</script>

<style lang="scss" scoped>
.editor-sytle {
  /deep/.ivu-form-item-content {
    z-index: 1;
  }
}

.page-container {
  .form-head {
    background: rgba(0, 0, 0, 0.05);
    padding: 16px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    padding-left: 24px;
  }

  .btn_wrap {
    width: 100%;

    .btn {
      width: 500px;
      margin: 0 auto;

      button {
        margin-left: 50px;
      }
    }
  }

  .form_base {
    margin-top: 10px;

    .info {
      margin-bottom: 20px;

      .info_item {
        display: inline-block;
        margin: 10px 0;
        margin-left: 60px;

        .time-tip {
          font-size: 12px;
          color: #d9001b;
        }

        .text {
          font-weight: 700;
        }

        .red {
          color: #d9001b;
        }

        .blue {
          color: #02a7f0;
        }
      }
    }

    .imgWrap {
      display: flex;
      max-width: 500px;
      flex-wrap: wrap;
      justify-content: flex-start;

      .imgBox {
        position: relative;
        margin: 5px 10px;

        .rightBox {
          width: 20px;
          height: 20px;
          background-color: rgba(0, 0, 0, 0.7);
          border-radius: 0 0 0 12px;
          position: absolute;
          top: 0;
          right: 0;
        }

        .delBtn {
          position: absolute;
          top: -5px;
          right: -5px;
          color: #fff;
          cursor: pointer;
        }

        img {
          width: 144px;
          height: 96px;
        }
      }
    }
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
}

.html-reset {
  /deep/ul {
    list-style-type: disc;
    list-style-position: inside;
  }

  /deep/ol {
    list-style-type: decimal;
    list-style-position: inside;
  }
}
</style>
